import { Icon, Spinner } from '@acpaas-ui/react-components';

const Switch = ({
  tip = '',
  tipOffsetTop = 48,
  tipWidth = 320,
  checked,
  isSubmitting,
  onClick,
  hasError,
  validationError,
  description,
  label,
  ...props
}) => {
  return (
    <div className="spo-a-switch__wrapper">
      <div className="a-input">
        {label && <label className="a-input__label">{label}</label>}
        <div className="a-switch">
          <button
            onClick={() => onClick(!checked)}
            className="a-switch__button"
            role="switch"
            aria-checked={checked}
            aria-label={label}
          >
            <span className="a-switch__off"></span>
            <span className="a-switch__on"></span>
          </button>
        </div>
      </div>
      {(!!validationError || hasError) && <small className="u-text-danger">{validationError || description}</small>}
      {isSubmitting && (
        <div className="submitting">
          <Spinner />
        </div>
      )}
      {tip && (
        <div className="spo-a-switch__tooltip-wrapper">
          <Icon className="u-text-light" name="ai-question-circle" />
          <div
            className="spo-a-switch__tooltip a-tooltip a-tooltip--primary a-tooltip--top"
            style={{ width: `${tipWidth}px`, top: `-${tipOffsetTop}px` }}
          >
            {tip}
          </div>
        </div>
      )}
    </div>
  );
};

export default Switch;
